<div class="flex justify-center p-5 min-w-[400px]">
  <form class="flex flex-col w-full max-w-md" [formGroup]="form">
    <h3 class="mb-5 max-w-xs text-center self-center text-xl font-semibold">
      Add Referring Doctor
    </h3>

    <div class="mb-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Doctor name</mat-label>
        <input
          matInput
          name="name"
          autocomplete="off"
          placeholder="name"
          formControlName="name"
        />
      </mat-form-field>
    </div>

        <div class="mb-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Doctor Phone</mat-label>
        <input
          matInput
          name="phone"
          autocomplete="off"
          placeholder="phone"
          formControlName="phone"
        />
      </mat-form-field>
    </div>

        <div class="mb-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Doctor Fax</mat-label>
        <input
          matInput
          name="fax"
          autocomplete="off"
          placeholder="fax"
          formControlName="fax"
        />
      </mat-form-field>
    </div>
    <div class="mb-4">
            <app-department-select
        [disabled]="isDepartmentDisabled"
        [required]="true"
        [selectedValue]="form.value.departmentId"
        (departmentSelected)="onDepartmentChange($event)"
      >
      </app-department-select>
    </div>

    <div class="flex justify-between pt-4 space-x-2">
      <button
        [disabled]="isLoading"
        type="button"
        mat-stroked-button
        class="border px-4 py-2 rounded-md"
        (click)="onClose()"
      >
        Cancel
      </button>

      <button
        [disabled]="isLoading"
        type="button"
        mat-flat-button
        color="primary"
        class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        (click)="save()"
      >
        {{isLoading ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </form>
</div>
